import { CircularProgress, Container } from '@mui/material';

export function Loader() {
  return (
    <Container sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    }}>
      <CircularProgress color="inherit" size={40} />
    </Container>
  );
}
